import { useHistory } from 'react-router-dom';
import DateFormatResolver, { fullDateUsFormat } from '../resolvers/date-format.resolver';
import layoutNames from 'utils/enums/layout-names.enum';
import { canByLicensing } from 'utils/licensing/licensingChecker';

export const alertTypes = {
	PASSWORD_IS_ABOUT_TO_EXPIRE: 'PASSWORD_IS_ABOUT_TO_EXPIRE',
	CALL_SCHEDULED: 'CALL_SCHEDULED',
	CALL_CANCELLED: 'CALL_CANCELLED',
	THRESHOLDS_NOTIFICATION: 'THRESHOLDS_NOTIFICATION',
};

export default (closeAlertDropdown) => {
	const history = useHistory();
	const alertPagePathName = `/${layoutNames.portal}/alerts`;

	const resolveAlertLink = (alert) => {
		const defaultAction = () => {
			if (history?.location?.pathname !== alertPagePathName) {
				history.push(alertPagePathName);
			}
			if (closeAlertDropdown) {
				closeAlertDropdown();
			}
		};

		switch (alert.code) {
			case alertTypes.PASSWORD_IS_ABOUT_TO_EXPIRE:
				history.push(`/${layoutNames.auth}/change-password`);
				break;
			case alertTypes.CALL_SCHEDULED:
				if (canByLicensing('scheduler.scheduleCall')) {
					if (alert?.payload?.appointmentId) {
						history.push(`/${layoutNames.portal}/scheduler/call/${alert?.payload?.appointmentId}`);
					}
				} else {
					defaultAction();
				}
				break;
			case alertTypes.CALL_CANCELLED:
				if (canByLicensing('scheduler.scheduleCall')) {
					history.push(`/${layoutNames.portal}/scheduler`);
				} else {
					defaultAction();
				}
				break;
			case alertTypes.THRESHOLDS_NOTIFICATION:
				if (canByLicensing('analytics.view')) {
					history.push(`/${layoutNames.portal}/reports`);
				} else {
					defaultAction();
				}
				break;
			default:
				defaultAction();
				break;
		}
	};

	const resolveAlertLinkText = (code) => {
		switch (code) {
			case alertTypes.PASSWORD_IS_ABOUT_TO_EXPIRE:
				return 'Click here to change Password';
			case alertTypes.CALL_SCHEDULED:
				if (canByLicensing('scheduler.scheduleCall')) {
					return 'Click here to proceed to Call details';
				}
				return false;
			case alertTypes.CALL_CANCELLED:
				if (canByLicensing('scheduler.scheduleCall')) {
					return 'Click here to proceed to Scheduler';
				}
				return false;
			case alertTypes.THRESHOLDS_NOTIFICATION:
				if (canByLicensing('analytics.view')) {
					return 'Click here to proceed to Dashboards';
				}
				return false;
			default:
				return false;
		}
	};

	const resolveAlertMessage = (code, text, payload) => {
		switch (code) {
			case alertTypes.CALL_SCHEDULED:
				return `You have a call scheduled for ${DateFormatResolver.resolve(payload.startTime, fullDateUsFormat)}`;
			case alertTypes.CALL_CANCELLED:
				return `The Appointment on ${DateFormatResolver.resolve(payload.startTime, fullDateUsFormat)} has been cancelled`;
			case alertTypes.PASSWORD_IS_ABOUT_TO_EXPIRE:
			case alertTypes.THRESHOLDS_NOTIFICATION:
			default:
				return text;
		}
	};


	return {
		resolveAlertLink,
		resolveAlertLinkText,
		resolveAlertMessage,
	};
};
